import Vue from "vue";
import Vuetify from "vuetify/lib";
// Fonts
import "material-design-icons-iconfont/dist/material-design-icons.css";
import { colors } from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
    values: {
      account: "mdi-folder-account",
      accountCard: "mdi-account-card-outline",
      accountCardActive: "mdi-account-card",
      accountCreditCard: "mdi-account-credit-card",
      actionList: "mdi-list-status",
      active: "mdi-toggle-switch",
      activity: "mdi-timeline-clock-outline",
      activityActive: "mdi-timeline-clock",
      add: "mdi-plus-circle",
      addOutline: "mdi-plus-circle-outline",
      address: "mdi-home-city-outline",
      alert: "mdi-alert-circle",
      alertNew: "mdi-timer-plus",
      alerts: "mdi-timer",
      ar: "mdi-hand-coin",
      arrowDown: "mdi-arrow-down",
      autoFix: "mdi-auto-fix",
      back: "mdi-chevron-left",
      bank: "mdi-bank",
      bankOutline: "mdi-bank-outline",
      accessEdit: "mdi-monitor-edit",
      budtenderTraining: "mdi-school",
      cancel: "mdi-close",
      delete: "mdi-close-circle",
      cashEdit: "mdi-cash-edit",
      checkCircle: "mdi-check-circle",
      cashFast: "mdi-cash-fast",
      cashMarker: "mdi-cash-marker",
      cashMinus: "mdi-cash-minus",
      chevronDown: "mdi-chevron-down",
      chevronUp: "mdi-chevron-up",
      childAccount: "mdi-account-child",
      components: "mdi-puzzle",
      copy: "mdi-content-copy",
      config: "mdi-cog",
      contact: "mdi-badge-account-horizontal",
      contacts: "mdi-contacts",
      country: "mdi-earth",
      createdBy: "mdi-clock-outline",
      creditCard: "mdi-credit-card",
      cursor: "mdi-cursor-default",
      dashboards: "mdi-monitor-dashboard",
      date: "mdi-calendar-range",
      disabled: "mdi-close-box",
      download: "mdi-download",
      email: "mdi-email",
      emailTemplates: "mdi-email-newsletter",
      endDate: "mdi-calendar-end",
      enabled: "mdi-checkbox-marked",
      eventStaffing: "mdi-briefcase-account",
      empty: "mdi-tray",
      expand: "mdi-chevron-down",
      expenses: "mdi-account-cash",
      expenseTypes: "mdi-file-sign",
      expenseVendors: "mdi-card-account-details",
      file: "mdi-file-document",
      fileNew: "mdi-file-document-plus",
      fileUpload: "mdi-file-upload",
      fileNewOutline: "mdi-file-document-plus-outline",
      filter: "mdi-filter",
      filterTable: "mdi-table-row-height",
      filterOff: "mdi-filter-off",
      folderOpen: "mdi-folder-open-outline",
      global: "mdi-earth",
      history: "mdi-history",
      info: "mdi-information-outline",
      infoActive: "mdi-information",
      invoice: "mdi-invoice-list",
      integrations: "mdi-dip-switch",
      kanban: "mdi-view-column",
      leadPool: "mdi-account-search",
      ledger: "mdi-calendar-text",
      license: "mdi-license",
      location: "mdi-warehouse",
      lock: "mdi-lock-open",
      manufacturing: "mdi-hammer-wrench",
      map: "mdi-map-marker-radius",
      marker: "mdi-marker",
      menu: "mdi-menu",
      menuDown: "mdi-menu-down",
      mixCalculator: "mdi-tune-vertical",
      money: "mdi-cash",
      mobileMenu: "mdi-dots-vertical",
      newTab: "mdi-open-in-new",
      next: "mdi-chevron-right",
      notes: "mdi-note",
      notification: "mdi-bell",
      notificationNew: "mdi-bell-plus",
      notificationOutline: "mdi-bell-outline",
      onboard: "mdi-handshake",
      onboarding: "mdi-timeline-check",
      order: "mdi-clipboard-list",
      orderComplete: "mdi-clipboard-check",
      orderNew: "mdi-clipboard-plus",
      overview: "mdi-view-dashboard-outline",
      overviewActive: "mdi-view-dashboard",
      parentAccount: "mdi-domain",
      paymentTerms: "mdi-cash-multiple",
      permissions: "mdi-shield-account",
      phoneNumber: "mdi-phone",
      priority: "mdi-fire",
      reports: "mdi-file-chart",
      plant: "mdi-tree",
      productCategory: "mdi-sitemap",
      productLot: "mdi-tag-text",
      products: "mdi-package-variant",
      projects: "mdi-chart-gantt",
      projectTemplates: "mdi-format-list-group-plus",
      promotion: "mdi-sale",
      qrTemplates: "mdi-qrcode",
      query: "mdi-cloud-search",
      rawMaterial: "mdi-cannabis",
      rawMaterialVendor: "mdi-power-plug",
      reminder: "mdi-timer-alert",
      reminderNew: "mdi-timer-plus",
      reminders: "mdi-timer-alert",
      remove: "mdi-trash-can",
      retailBrand: "mdi-store",
      review: "mdi-help-circle",
      room: "mdi-floor-plan",
      schedule: "mdi-calendar-clock",
      search: "mdi-magnify",
      send: "mdi-send-variant",
      shipping: "mdi-package-variant-closed",
      socials: "mdi-account-voice",
      star: "mdi-star",
      startDate: "mdi-calendar-start",
      state: "mdi-map-marker",
      storeEvent: "mdi-calendar-multiple",
      submit: "mdi-check",
      subtract: "mdi-minus",
      supportTicket: "mdi-briefcase",
      table: "mdi-table",
      taskSearch: "mdi-text-box-search",
      task: "mdi-fheck",
      tasks: "mdi-file-tree",
      taskType: "mdi-format-list-bulleted",
      team: "mdi-account-multiple",
      terpene: "mdi-water",
      testingLab: "mdi-test-tube",
      transfer: "mdi-transfer",
      undo: "mdi-undo",
      update: "mdi-pencil",
      updatedBy: "mdi-update",
      user: "mdi-account",
      userNew: "mdi-account-plus",
      users: "mdi-account-group",
      vendorOrder: "mdi-truck",
      vendors: "mdi-package-variant-closed-check",
      view: "mdi-eye",
      views: "mdi-view-dashboard-variant",
      website: "mdi-link-variant",
      whiteLabel: "mdi-package",
      workOrder: "mdi-beaker",
      workOrderComplete: "mdi-beaker-check",
      workOrderNew: "mdi-beaker-plus",
    },
  },
  theme: {
    defaultTheme: "dark",
    options: { customProperties: true },
    themes: {
      light: {
        primary: colors.shades.black,
        secondary: colors.shades.white,
        bg: colors.grey.lighten4,
        background: colors.grey.lighten4,
        background: colors.grey.lighten4,
        background2: colors.grey.lighten3,
        background3: colors.grey.lighten2,
        background4: colors.grey.lighten1,
        background5: colors.grey.base,
        background6: colors.grey.darken1,
        secondaryBackground: colors.shades.white,
        secondarySheet: colors.grey.lighten4,
        icon: colors.grey.darken3,
        secondaryIcon: colors.grey.darken1,
        review: colors.blue.base,
        border: colors.grey.lighten2,
        secondaryBorder: colors.grey.base,
        loading: colors.grey.darken2,
        sample: colors.blue.lighten2,
        information: colors.blue.lighten1,
        paused: colors.deepPurple.base,
        success: colors.green.base,
        error: colors.red.base,
        update: colors.orange.base,
        contacts: colors.deepPurple.base,
        money: colors.green.darken3,
        shipping: colors.purple.base,
        orders: colors.orange.darken2,
        products: colors.brown.base,
        ledger: colors.grey.lighten1,
        promotion: colors.teal.base,
        promoUnit: colors.lightBlue.darken3,
        overpaymentCredit: colors.blueGrey.base,
        productLot: colors.indigo.darken4,
        accounts: colors.cyan.lighten1,
        tasks: colors.blueGrey.base,
        trainings: "#ff7373",
        navBar: colors.shades.black,
        promoText: "#9421d1",
        promoBackground: "#D320FF",
        colors,
        required: colors.yellow.lighten3,
        optional: colors.grey.lighten4,
        updated: colors.orange.lighten3,
        greyText: "#444746",
        gradient: `linear-gradient(to right, #0f2027, #203a43, #2c5364)`,
      },
      dark: {
        primary: colors.shades.white,
        secondary: colors.shades.black,
        bg: "#121212",
        background: "#121212",
        background2: "#282828",
        background3: "#3f3f3f",
        background4: "#575757",
        background5: "#717171",
        background6: "#b6b6b6",
        secondaryBackground: "#1e1e1e",
        secondarySheet: "#272727",
        icon: colors.grey.lighten4,
        secondaryIcon: colors.grey.lighten2,
        review: colors.lightBlue.lighten1,
        border: "#565656",
        secondaryBorder: colors.grey.darken2,
        loading: colors.grey.base,
        sample: colors.blue.lighten2,
        information: colors.blue.lighten2,
        paused: colors.deepPurple.base,
        success: colors.green.base,
        error: colors.red.accent2,
        update: colors.orange.lighten1,
        contacts: colors.deepPurple.base,
        money: colors.green.darken3,
        shipping: colors.purple.base,
        orders: colors.orange.darken2,
        products: colors.brown.lighten2,
        ledger: colors.grey.base,
        promotion: colors.teal.lighten2,
        promoUnit: colors.lightBlue.darken3,
        overpaymentCredit: colors.blueGrey.base,
        productLot: colors.indigo.darken4,
        accounts: colors.cyan.lighten1,
        tasks: colors.blueGrey.lighten1,
        trainings: "#ff7373",
        navBar: colors.grey.darken4,
        promoText: "#D99AFC",
        promoBackground: "#D320FF",
        colors,
        required: colors.yellow.darken3,
        optional: colors.grey.darken2,
        updated: colors.orange.darken3,
        greyText: "#C4C7C5",
        gradient: `linear-gradient(159deg, rgba(0,0,128,1) 0%, rgba(0,191,255,1) 100%)`,
      },
    },
  },
});
